import { useState, useCallback } from 'react';

export const useSearchList = () => {
  const [isOpen, setIsOpen] = useState(false);

  const close = useCallback(() => {
    setIsOpen(false);
  }, [isOpen]);

  const open = useCallback(() => {
    setIsOpen(true);
  }, [isOpen]);

  const toggle = useCallback(() => {
    setIsOpen((state) => !state);
  }, [isOpen]);

  return {
    isSearchListShown: isOpen,
    hideSearchList: close,
    showSearchList: open,
    toggleSearchList: toggle,
  };
};
